module.exports = __webpack_public_path__ + "static/media/companyBg.9f451883.png";